"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Paginator_1 = require("./Paginator");
Object.defineProperty(exports, "Paginator", { enumerable: true, get: function () { return Paginator_1.Paginator; } });
//# sourceMappingURL=index.js.map